const Act = {
  /* test */
  TEST: "TEST",

  /* common */
  COMMON_SET_MESSAGE: "COMMON_SET_MESSAGE",
  COMMON_SET_SUCCESS_MESSAGE: "COMMON_SET_SUCCESS_MESSAGE",
  COMMON_SET_INFO_MESSAGE: "COMMON_SET_INFO_MESSAGE",
  COMMON_SET_WARNING_MESSAGE: "COMMON_SET_WARNING_MESSAGE",
  COMMON_SET_ERROR_MESSAGE: "COMMON_SET_ERROR_MESSAGE",
  COMMON_CLEAR_MESSAGE: "COMMON_CLEAR_MESSAGE",
  COMMON_MODULE_SETTING: "COMMON_MODULE_SETTING",
  COMMON_SET_LOADER: "COMMON_SET_LOADER",

  /* theme */
  THEME_SET_FONT_SIZE_SCALE: "THEME_SET_FONT_SIZE_SCALE",
  THEME_SET_LIGHT_DARK_MODE: "THEME_SET_LIGHT_DARK_MODE",

  /* user */
  SET_USER_LOCALE: "SET_USER_LOCALE",
  SET_USER_TOKEN: "SET_USER_TOKEN",
  FIREBASE_LOGIN_USER: "FIREBASE_LOGIN_USER",
  FIREBASE_LOGOUT_USER: "FIREBASE_LOGOUT_USER",
  USER_REFRESH_USER_INFO: "USER_REFRESH_USER_INFO",
  USER_REFRESH_USER_GROUPS: "USER_REFRESH_USER_GROUPS",
  USER_SET_CUR_GROUP: "USER_SET_CUR_GROUP",
  USER_SET_GROUPS: "USER_SET_GROUPS",
  USER_SET_ROLE: "USER_SET_ROLE",

  /* sna */
  SNA_SIDE_BAR: "SNA_SIDE_BAR",
  SNA_SIDEBAR_FILE_TOOL: "SNA_SIDEBAR_FILE_TOOL",
  SNA_SET_EVN_CTG_SETTING_TOOL_ISLOADING:
    "SNA_SET_EVN_CTG_SETTING_TOOL_ISLOADING",
  SNA_DIALOG_CONTEXT: "SNA_DIALOG_CONTEXT",
  SNA_SET_EDIT_DIALOG: "SNA_SET_EDIT_DIALOG",
  SNA_SET_EVN_CTG_DIALOG: "SNA_SET_EVN_CTG_DIALOG",
  //
  SNA_REFRESH_PUBLIC_DATASET: "SNA_REFRESH_PUBLIC_DATASET",
  SNA_REFRESH_PERSONAL_DATASET: "SNA_REFRESH_PERSONAL_DATASET",
  SNA_REFRESH_GROUP_DATASET: "SNA_REFRESH_GROUP_DATASET",
  SNA_SET_AI_QUOTA: "SNA_SET_AI_QUOTA",
  SNA_SET_OCR_QUOTA: "SNA_SET_OCR_QUOTA",
  SNA_SET_QUOTA: "SNA_SET_QUOTA",
  SNA_SET_OCR_ORIGINAL_DATA: "SNA_SET_OCR_ORIGINAL_DATA",

  //
  SNA_APPLY_FETCH_DATASET: "SNA_APPLY_FETCH_DATASET",
  SNA_APPLY_ADJUST_SETTING: "SNA_APPLY_ADJUST_SETTING",
  SNA_APPLY_FILTER_SETTING: "SNA_APPLY_FILTER_SETTING",
  SNA_APPLY_ANALYTICS: "SNA_APPLY_ANALYTICS",
  // display area
  SNA_DISPLAY_SNA_REF: "SNA_DISPLAY_SNA_REF",
  SNA_DISPLAY_DRAW_NETWORK_DATA: "SNA_DISPLAY_DRAW_NETWORK_DATA",
  SNA_DISPLAY_MEMO_WIDTH: "SNA_DISPLAY_MEMO_WIDTH",
  SNA_DISPLAY_MEMO_HEIGHT: "SNA_DISPLAY_MEMO_HEIGHT",
  SNA_DISPLAY_FOCUS_NODES: "SNA_DISPLAY_FOCUS_NODES",
  // file tool
  SNA_CUR_DATASET: "SNA_CUR_DATASET",
  SNA_CUR_DATASET_CLEAR: "SNA_CUR_DATASET_CLEAR",
  SNA_DATASET_PUBLIC: "SNA_DATASET_PUBLIC",
  SNA_DATASET_PERSONAL: "SNA_DATASET_PERSONAL",
  SNA_DATASET_GROUP: "SNA_DATASET_GROUP",
  // adjust tool
  SNA_ADJUST_MAIN: "SNA_ADJUST_MAIN",
  SNA_ADJUST_NODE_COLORS_INITIAL: "SNA_ADJUST_NODE_COLORS_INITIAL",
  SNA_ADJUST_NODE_COLORS_CHANGE: "SNA_ADJUST_NODE_COLORS_CHANGE",
  SNA_ADJUST_LINK_COLORS_INITIAL: "SNA_ADJUST_LINK_COLORS_INITIAL",
  SNA_ADJUST_LINK_COLORS_CHANGE: "SNA_ADJUST_LINK_COLORS_CHANGE",
  SNA_ADJUST_NODE_PLACEMENT: "SNA_ADJUST_NODE_PLACEMENT",
  SNA_ADJUST_NODE_PLACEMENT_INITIAL: "SNA_ADJUST_NODE_PLACEMENT_INITIAL",
  SNA_ADJUST_NODE_PLACEMENT_CHANGE: "SNA_ADJUST_NODE_PLACEMENT_CHANGE",
  SNA_ADJUST_NODE_SHOW_NODE_COUNT_INITIAL:
    "SNA_ADJUST_NODE_SHOW_NODE_COUNT_INITIAL",
  SNA_ADJUST_NODE_SHOW_NODE_COUNT_CHANGE:
    "SNA_ADJUST_NODE_SHOW_NODE_COUNT_CHANGE",
  SNA_ADJUST_NODE_DISPERSION_INITIAL: "SNA_ADJUST_NODE_DISPERSION_INITIAL",
  SNA_ADJUST_NODE_DISPERSION_CHANGE: "SNA_ADJUST_NODE_DISPERSION_CHANGE",
  SNA_ADJUST_LEGEND_SHOW_NO_DATA_GROUP_INITIAL:
    "SNA_ADJUST_LEGEND_SHOW_NO_DATA_GROUP_INITIAL",
  SNA_ADJUST_LEGEND_SHOW_NO_DATA_GROUP_CHANGE:
    "SNA_ADJUST_LEGEND_SHOW_NO_DATA_GROUP_CHANGE",
  // filter tool
  SNA_FILTER_MAIN: "SNA_FILTER_MAIN",
  SNA_EVENT_TYPES_FILTER_ON_INITIAL: "SNA_EVENT_TYPES_FILTER_ON_INITIAL",
  SNA_EVENT_TYPES_FILTER_ON_CHANGE: "SNA_EVENT_TYPES_FILTER_ON_CHANGE",
  SNA_EVENT_TYPES_INITIAL: "SNA_EVENT_TYPES_INITIAL",
  SNA_EVENT_TYPES_CHANGE: "SNA_EVENT_TYPES_CHANGE",
  SNA_EVENT_TYPES_ORIGIN: "SNA_EVENT_TYPES_ORIGIN",
  SNA_EVENT_TYPES_CUSTOM: "SNA_EVENT_TYPES_CUSTOM",
  SNA_FILTER_NODE_COUNT_INITIAL: "SNA_FILTER_NODE_COUNT_INITIAL",
  SNA_FILTER_NODE_COUNT_CHANGE: "SNA_FILTER_NODE_COUNT_CHANGE",
  SNA_FILTER_LINK_COUNT_INITIAL: "SNA_FILTER_LINK_COUNT_INITIAL",
  SNA_FILTER_LINK_COUNT_CHANGE: "SNA_FILTER_LINK_COUNT_CHANGE",
  SNA_FILTER_LIMIT_TOTAL_NODES_INITIAL: "SNA_FILTER_LIMIT_TOTAL_NODES_INITIAL",
  SNA_FILTER_LIMIT_TOTAL_NODES_CHANGE: "SNA_FILTER_LIMIT_TOTAL_NODES_CHANGE",
  SNA_FILTER_TIME_PERIOD_INITIAL: "SNA_FILTER_TIME_PERIOD_INITIAL",
  SNA_FILTER_TIME_PERIOD_CHANGE: "SNA_FILTER_TIME_PERIOD_CHANGE",
  SNA_FILTER_START_END_DATE_INITIAL: "SNA_FILTER_START_END_DATE_INITIAL",
  SNA_FILTER_START_END_DATE_CHANGE: "SNA_FILTER_START_END_DATE_CHANGE",
  SNA_FILTER_NODE_AUTHOR_PRESERVE_INITIAL:
    "SNA_FILTER_NODE_AUTHOR_PRESERVE_INITIAL",
  SNA_FILTER_NODE_AUTHOR_PRESERVE_CHANGE:
    "SNA_FILTER_NODE_AUTHOR_PRESERVE_CHANGE",
  // SNA_FILTER_NODE_COUNT_MEET_AUTH_INITIAL:
  //   "SNA_FILTER_NODE_COUNT_MEET_AUTH_INITIAL",
  // SNA_FILTER_NODE_COUNT_MEET_AUTH_CHANGE:
  //   "SNA_FILTER_NODE_COUNT_MEET_AUTH_CHANGE",
  SNA_FILTER_NODE_COUNT_MEET_AUTH_NEW_INITIAL:
    "SNA_FILTER_NODE_COUNT_MEET_AUTH_NEW_INITIAL",
  SNA_FILTER_NODE_COUNT_MEET_AUTH_CHANGE_NEW:
    "SNA_FILTER_NODE_COUNT_MEET_AUTH_CHANGE_NEW",
  // analytics
  SNA_ANALYTICS_TYPE_INITIAL: "SNA_ANALYTICS_TYPE_INITIAL",
  SNA_ANALYTICS_TYPE_CHANGE: "SNA_ANALYTICS_TYPE_CHANGE",
  SNA_ANALYTICS_START_ANALYSIS: "SNA_ANALYTICS_START_ANALYSIS",
  SNA_ANALYTICS_DISPLAY_WINDOW: "SNA_ANALYTICS_DISPLAY_WINDOW",
  // diaryInfo
  SNA_DIARY_INFO_EVENT_LIST: "SNA_DIARY_INFO_EVENT_LIST",
  SNA_DIARY_INFO_CUR_PAGE: "SNA_DIARY_INFO_CUR_PAGE",
  SNA_DIARY_INFO_PAGES: "SNA_DIARY_INFO_PAGES",
  SNA_DIARY_INFO_CUR_PAGE_ROWS: "SNA_DIARY_INFO_CUR_PAGE_ROWS",
  SNA_DIARY_INFO_DISPLAY_WINDOW: "SNA_DIARY_INFO_DISPLAY_WINDOW",
  SNA_DIARY_INFO_START_SEARCH: "SNA_DIARY_INFO_START_SEARCH",

  // subPage
  SNA_SET_SUBPAGE: "SNA_SET_SUBPAGE",
  SNA_SET_AI_CURRENT_PAGE: "SNA_SET_AI_CURRENT_PAGE",
  SNA_SET_AI_INPUT_TXT: "SNA_SET_AI_INPUT_TXT",
  SNA_SET_AI_IS_FETCH_DATA: "SNA_SET_AI_IS_FETCH_DATA",
  SNA_SET_AI_FETCH_DATA: "SNA_SET_AI_FETCH_DATA",
  SNA_SET_AI_IS_WATCHING_INPUT: "SNA_SET_AI_IS_WATCHING_INPUT",
  SNA_SET_AI_TABLE_DATA: "SNA_SET_AI_TABLE_DATA",
  SNA_SET_AI_TABLE_TOTAL_PAGE: "SET_AI_TABLE_TOTAL_PAGE",
  SNA_SET_AI_TABLE_CURRENT_PAGE: "SET_AI_TABLE_CURRENT_PAGE",
  SNA_SET_AI_TABLE_ITEM_PER_PAGE: "SET_AI_TABLE_ITEM_PER_PAGE",
  // import tool

  // export tool
  SNA_EXPORT_IMAGE_RESOLUTION: "SNA_EXPORT_IMAGE_RESOLUTION",
  SNA_EXPORT_IMAGE_MINE_TYPE: "SNA_EXPORT_IMAGE_MINE_TYPE",
  SNA_EXPORT_FILE_MINE_TYPE: "SNA_EXPORT_FILE_MINE_TYPE",
  SNA_EXPORT_START_EXPORT_FILE: "SNA_EXPORT_START_EXPORT_FILE",
  SNA_EXPORT_START_EXPORT_IMAGE: "SNA_EXPORT_START_EXPORT_IMAGE",

  /* digital ai */
  DIGITAL_AI_SET_IMG_LIST: "DIGITAL_AI_SET_IMG_LIST",
  DIGITAL_AI_SET_ACTIVE_PAGE: "DIGITAL_AI_SET_ACTIVE_PAGE",
  DIGITAL_AI_SET_TOTAL_PAGE: "DIGITAL_AI_SET_TOTAL_PAGE",
  DIGITAL_AI_SET_UPLOAD_OCR_FILES_STATUS:
    "DIGITAL_AI_SET_UPLOAD_OCR_FILES_STATUS",
  DIGITAL_AI_SET_OCR_STATUS: "DIGITAL_AI_SET_OCR_STATUS",
  DIGITAL_AI_SET_OCR_FILE_NAME: "DIGITAL_AI_SET_OCR_FILE_NAME",
  DIGITAL_AI_SET_OCR_FINISH: "DIGITAL_AI_SET_OCR_FINISH",
  DIGITAL_AI_INIT: "DIGITAL_AI_INIT",
  DIGITAL_OCR_ERROR_COUNT: "DIGITAL_OCR_ERROR_COUNT",
  DIGITAL_OCR_UPLOAD_ERROR: "DIGITAL_OCR_UPLOAD_ERROR",

  /* gis */
  // TEST: "TEST",

  /* help */
  // TEST: "TEST",

  /* error page */
  ERROR_SET_ERROR: "ERROR_SET_ERROR",
  ERROR_CLEAR_ERROR: "ERROR_CLEAR_ERROR",
  ERROR_CLEAR_ALL_ERROR: "ERROR_CLEAR_ALL_ERROR",
};

export default Act;
